import { Validators } from '@angular/forms';
import { OneClickPaymentsEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-payments.effects';
import { OneClickStandardLotEffects } from '@ordersnproducts/modules/one-click-order/effects/one-click-standard-lot.effects';
import { OneClickDeliveryMethodProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-delivery-method.provider';
import { OneClickPreviewStandardLotLoadingProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-preview-standard-lot-loading.provider';
import { OneClickSetStandardLotOrder } from '@ordersnproducts/modules/one-click-order/services/commands/one-click-update-standard-lot.command.service';
import { OneClickStdLotLoaderService } from '@ordersnproducts/modules/one-click-order/services/loaders/one-click-standard-lot.loader.service';
import { FormGenericItemComponent } from '../../../../../shared/modules/configurable-form/components/form-generic-item/form-generic-item.component';
import { FieldConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-config.interface';
import { FieldLabelConfig } from '../../../../../shared/modules/configurable-form/models/field-configs/field-label-config.interface';
import { OneClickLocationProvider } from '../../../../providers/order/one-click-location.provider';
import { OneClickLocationDisplayer } from '../../../../providers/order/one-click-multiple-jobsite-displayer.provider';
import {
  OneClickHasResultProvider,
  OneClickNoResultProvider,
  OneClickPaymentProvider,
} from '../../../../providers/order/one-click-payment.provider';
import { OneClickPreviewPaymentLoadingProvider } from '../../../../providers/order/one-click-preview-payment-loading.provider';
import { OneClickProductProvider } from '../../../../providers/order/one-click-product.provider';
import { OneClickStandardLotProvider } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-standard-lot.provider';
import { OneClickSetPayment } from '../../../../services/commands/one-click-update-payment.command.service';
import { OneClickPaymentsExtendedLoaderService } from '../../../../services/loaders/one-click-payments-extended.loader.service';
import { OneClickBuilderField } from '../../../../util/constants/builder-fields';
import { OneClickPreviewField } from '../../../../util/constants/preview-fields';
import { FieldSelectConfig } from './../../../../../shared/modules/configurable-form/components/form-multiselect/models/field-select-config.interface';
import { FormSelectComponent } from './../../../../../shared/modules/configurable-form/components/form-select/form-select.component';
import { FormSeparatorComponent } from '@ordersnproducts/modules/shared/modules/configurable-form/components/form-separator/form-separator.component';
import { OneClickMultipleOption } from '@ordersnproducts/modules/one-click-order/providers/order/one-click-is-multiple-option.provider';

export const preview: FieldConfig[] = [
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Jobsite,
    label: 'views.one_click.jobsite',
    hidden: OneClickLocationDisplayer.HideJobsite,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-md-12 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagjobsite',
    dataTIdValue: 'cmx-createoneclickorder-lblvaljobsite',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.PointOfDelivery,
    label: 'views.one_click.pod',
    hidden: OneClickLocationDisplayer.HidePointOfDelivery,
    text: OneClickLocationProvider.TextPreview,
    containerClassNames: ['col-md-12 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpointofdelivery',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpointofdelivery',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.DeliveryMethod,
    text: OneClickDeliveryMethodProvider.TextPreview,
    label: 'views.one_click.delivery_method',
    containerClassNames: ['col-md-2 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagdeliverymethod',
    dataTIdValue: 'cmx-createoneclickorder-lblvaldeliverymethod',
  } as FieldLabelConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Product,
    text: OneClickProductProvider,
    label: 'views.one_click.product',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagproduct',
    dataTIdValue: 'cmx-createoneclickorder-lblvalproduct',
  } as FieldLabelConfig,
  {
    type: FormSeparatorComponent,
    name: '',
    containerClassNames: ['col-md-12'],
    hidden: OneClickHasResultProvider,
    visible: OneClickMultipleOption.IsSingleOption,
  } as FieldConfig,
  {
    type: FormSelectComponent,
    name: OneClickPreviewField.StandardLot,
    label: 'views.one_click.std_lot',
    placeholder: 'views.one_click.select.std_lot',
    optionsLoader: OneClickStdLotLoaderService,
    loading: OneClickPreviewStandardLotLoadingProvider,
    hidden: OneClickHasResultProvider,
    onChange: [OneClickSetStandardLotOrder],
    dynamicEffects: [OneClickStandardLotEffects],
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.StandardLot,
    hidden: OneClickNoResultProvider,
    text: OneClickStandardLotProvider,
    label: 'views.one_click.std_lot',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagstdlotsize',
    dataTIdValue: 'cmx-createoneclickorder-lblvalstdlotsize',
  } as FieldLabelConfig,
  {
    type: FormSelectComponent,
    name: OneClickBuilderField.Payment,
    label: 'views.one_click.payment_method',
    placeholder: 'views.one_click.select_payment',
    optionsLoader: OneClickPaymentsExtendedLoaderService,
    loading: OneClickPreviewPaymentLoadingProvider,
    hidden: OneClickHasResultProvider,
    onChange: [OneClickSetPayment],
    dynamicEffects: [OneClickPaymentsEffects],
    containerClassNames: ['col-md-6 text-capitalize retail-control'],
    validation: [Validators.required],
  } as FieldSelectConfig,
  {
    type: FormGenericItemComponent,
    name: OneClickPreviewField.Payment,
    hidden: OneClickNoResultProvider,
    text: OneClickPaymentProvider,
    label: 'views.one_click.payment_method',
    containerClassNames: ['col-md-6 text-capitalize'],
    dataTIdLabel: 'cmx-createoneclickorder-lbltagpayment',
    dataTIdValue: 'cmx-createoneclickorder-lblvalpayment',
  } as FieldLabelConfig,
];
